import { ReactElement } from 'react';

const LandingBody = ({ form, setForm, products, brands, selectedBrands, setSelectedBrands, productGroups, setProductGroups, banners, setBanners, posts, setPosts }) => {
  const bannerSlider = () => {
    const rows: ReactElement[] = [];
    Object.entries(banners).filter(([key, value]) => key.includes('slider')).map(([key, value], index) => {
      rows.push(
        <span className="smallCard" style={{ backgroundImage: `url("${(banners['slider-' + index] || {})?.preview}")` }}>
         <label htmlFor={'bannerSlider' + index} className="plus">+</label>
          <input type="file" id={'bannerSlider' + index} className="hidden" onChange={(input) => setBanners(prev => {
            const data = banners['slider-' + index] || {};

            data['slider-' + index] = input.target.files[0];
            data.preview = URL.createObjectURL(input.target.files[0]);
            data.mediaId = null;

            return {
              ...prev,
              ['slider-' + index]: data
            };
          })}/>
          <input type="text" placeholder="لینک" value={(banners['slider-' + index] || {})?.link} className="smallCardInput" onChange={(input) => setBanners(prev => {
            const data = banners['slider-' + index] || {};

            data.link = input.target.value;

            return {
              ...prev,
              ['slider-' + index]: data
            };
          })}/>
          <input type="text" placeholder="متن جایگزین" value={(banners['slider-' + index] || {})?.alt} className="smallCardInput" onChange={(input) => setBanners(prev => {
            const data = banners['slider-' + index] || {};

            data.alt = input.target.value;

            return {
              ...prev,
              ['slider-' + index]: data
            };
          })}/>
        </span>
      );
    });

    return rows.reverse();
  };

  const singleBanner = (code: string) => {
    return (
      <>
        <label htmlFor={code} className="plus">+</label>
        <input type="file" id={code} className="hidden" onChange={(input) => setBanners(prev => {
          const data = banners[code] || {};

          data[code] = input.target.files[0];
          data.preview = URL.createObjectURL(input.target.files[0]);
          data.mediaId = null;

          return {
            ...prev,
            [code]: data
          };

        })}/>
        <input type="text" className="textInput" value={(banners[code] || {})?.link} placeholder="لینک" onChange={(input) => setBanners(prev => {
          const data = banners[code] || {};

          data.link = input.target.value;

          return {
            ...prev,
            [code]: data
          };
        })}/>
        <input type="text" className="textInput" value={(banners[code] || {})?.alt} placeholder="متن جایگزین" onChange={(input) => setBanners(prev => {
          const data = banners[code] || {};

          data.alt = input.target.value;

          return {
            ...prev,
            [code]: data
          };
        })}/>
      </>
    );
  };

  const productGroup = (productGroupIndex: number) => {
    if (!productGroups[productGroupIndex]){
      return <></>
    }
    const rows: ReactElement[] = [];

    productGroups[productGroupIndex]?.products?.map((product, index) => {
      rows.push(
        <span className="proCard">
          <select className="selector1" value={product} onChange={(input) => setProductGroups(prev => {
            const data = { ...prev[productGroupIndex] };
            data.products[index] = input.target.value;
            return prev.map((e, index) => index == productGroupIndex ? data : e);
          })}>
            {products.map(product => <option value={product.id}>{product.title}</option>)}
          </select>
        </span>
      );
    });

    return (
      <>
        <input type="text" className="textInput" value={productGroups[productGroupIndex].title} onChange={(input) => setProductGroups(prev => {
          const data = { ...prev[productGroupIndex] };
          data.title = input.target.value;
          return prev.map((e, index) => index == productGroupIndex ? data : e);
        })}/>
        <div className="banners">
          <span className="smallCard addCard" onClick={() => setProductGroups(prev => {
            const data = { ...prev[productGroupIndex] };
            data.products.push('');
            return prev.map((e, index) => index == productGroupIndex ? data : e);
          })}>
            +
          </span>
          {rows}
        </div>
      </>
    );
  };

  return (
    <>
    <section className="landing">
      <label>عنوان</label>
      <input value={form.title} onChange={(input) => setForm(prev => ({
        ...prev,
        title: input.target.value
      }))}/>
      <div className="banner" style={{ backgroundImage: `url("${banners && banners['top']?.preview}")` }}>
        {singleBanner('top')}
      </div>
      <div className="banners">
            <span className="smallCard addCard" onClick={() => setBanners(prev => ({
              ...prev,
              ['slider-' + Object.keys(banners).filter(e => e.includes('slider')).length]: {}
            }))}>
              +
            </span>
        {bannerSlider()}
      </div>
      <div className="banner" style={{ backgroundImage: `url("${banners && banners['middleFull']?.preview}")` }}>
        {singleBanner('middleFull')}
      </div>
      {productGroup(0)}
      <div className="banners">
            <span className="bigBanner" style={{ backgroundImage: `url("${banners && banners['middleRight']?.preview}")` }}>
              {singleBanner('middleRight')}
            </span>
        <span className="smallBanner" style={{ backgroundImage: `url("${banners && banners['middleLeft']?.preview}")` }}>
              {singleBanner('middleLeft')}
            </span>
      </div>
      {productGroup(1)}
      <div className="banner" style={{ backgroundImage: `url("${banners && banners['middleBottom']?.preview}")` }}>
        {singleBanner('middleBottom')}
      </div>
      <h3>برندهای منتخب</h3>
      <div className="banners">
             <span className="smallCard addCard" onClick={() => setSelectedBrands(prev => [...prev, ''])}>
              +
            </span>
        {selectedBrands.map((e, index) =>
          <span className="proCard" key={'brand' + index}>
                  <select className="selector1" defaultValue={e} onChange={(input) => setSelectedBrands(prev => prev.map((e, i) => i == index ? input.target.value : e))}>
                    {brands.map(brand => <option value={brand.id}>{brand.title}</option>)}
                  </select>
                </span>
        )}
      </div>
      <div className="banners">
        {[...Array(4)].map((e, index) =>
          <span className="proCard">
                  <select className="selector1" value={productGroups[2]?.products[index]} onChange={(input) => setProductGroups(prev => {
                    let data = prev[2] || {};

                    if(!data.products){
                      data.products = {}
                    }

                    data.products[index] = input.target.value;
                    return prev.map((e, i) => i == 2 ? data : e);
                  })}>
                    {products.map(product => <option value={product.id}>{product.title}</option>)}
                  </select>
                </span>
        )}
        <span className="smallCard" style={{ backgroundImage: `url("${banners && banners['bottom']?.preview}")` }}>
              {singleBanner('bottom')}
            </span>
      </div>
      <textarea value={form.description} onChange={(input) => setForm(prev => ({
        ...prev,
        description: input.target.value
      }))}></textarea>
    </section>
      <section className="landing">
        پست های بلاگ
        {posts?.map((post, index) => <span className="blogPosts" key={'postSpan' + index}>
              <input id={'post' + index} className="editProductInput width100" value={post} onChange={(input) => setPosts(prev => {
                const cp = [...prev];

                cp[index] = input.target.value;

                return cp;
              })}>
              </input>
              <label htmlFor={'post' + index}>:URL</label>
            </span>)}

        <button className="dashboardHeader" onClick={() => setPosts(prev => [...(prev || []), ''])}>افزودن پست</button>

      </section>
      </>
  );
};

export default LandingBody;
